<div class="display-block">
  {{ title }}
  <div class="right">
    @if (displayListResult === true) {
      <button
        class="btnsize"
        type="button" pButton
        pTooltip="{{'Return_Res' | translate}}"
        tooltipPosition="left"
        icon="pi icons8-retour" styleClass="p-button-success"
        (click)="returnList()"
      ></button>
    }
  </div>
</div>

@if (index == 1) {
  <displayresult
    #dispresult
    [srchMode]="srchMode"
    [resultDisplay]="resultDisplay"
    [btnAction]="true"
    [nbDoc]="nbDoc"
    [listColumns]="listColumns"
    [infoList]="infoList"
    [currentSelectedBsk]="{}"
    [listBskVariable]="[]"
    [basketMoveAll]="[]"
    [curPage]="curPage"
    [request]=""
    [isDesktop]="isDesktop"
    [autoDocId]="''"
    [fetchParam]="fetchParam"
    [userList]="userList"
    (onReturnResult)="onReturnResult($event)"
    (onAction)="onAction($event)"
    (onNextDocs)="onNextDocs()"
    >
  </displayresult>
}
